/**
 * WebVTT result types.
 *
 * @group WebVTT
 *
 * @beta
 *
 * @enum
 */
export const WebVttResultType = {
    CUE: 'cue',
    REGION: 'region',
    TIMESTAMP_MAP: 'timestampmap',
    STYLE: 'style',
    ERROR: 'error',
};
//# sourceMappingURL=WebVttResultType.js.map